import script from "./NotificheToolbarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificheToolbarButton.vue?vue&type=script&setup=true&lang=js"

import "./NotificheToolbarButton.vue?vue&type=style&index=0&id=6924fc2c&lang=scss&scoped=true"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6924fc2c"]])

export default __exports__